import React from 'react';
import {Label} from '@gravity-ui/uikit';
import {useAdminConversations} from '../../../entities/conversation';

export const ConversationsBadge = () => {
  const {awaitingCount} = useAdminConversations();

  if (!awaitingCount) return null;

  return (
    <Label theme="warning" size="s">
      {awaitingCount}
    </Label>
  );
};
